import { Button } from "@kovernow/react-ui/components/button";
import { Link } from "react-router";
import { Page } from "../components/Page";
import { useT } from "../core/use-t";

/**
 * Placeholder for a phase 1 journey not built yet (CAP-4). Later stories
 * replace the element; links to the route work from day one.
 */
export function Placeholder({ titleKey, flowKey }: { titleKey: string; flowKey?: string }) {
  const t = useT();
  return (
    <Page titleKey={titleKey} flowKey={flowKey}>
      <p className="text-muted-foreground" data-testid="placeholder">
        {t("common.comingSoon")}
      </p>
      <Button asChild variant="outline" size="touch" className="mt-6">
        <Link to="/">{t("common.goHome")}</Link>
      </Button>
    </Page>
  );
}

export function NotFoundPage() {
  const t = useT();
  return (
    <Page titleKey="common.notFoundTitle">
      <p className="text-muted-foreground">{t("common.notFoundBody")}</p>
      <Button asChild variant="cta" size="touch" className="mt-6">
        <Link to="/">{t("common.goHome")}</Link>
      </Button>
    </Page>
  );
}
